import React from 'react';
import ErrorFeedbackForm from '../Forms/Feedback/ErrorFeedback';

const ServerError = ({ error }) => {
  const errorCopy = (
      <div className="modals-popup login-modal">
        <div className="modal-header d-flex align-items-center">
          <div className="col">Looks like we&apos;re having trouble loading the page</div>
        </div>
        <div className="info text-center p-3">
          It seems there was an issue trying to load the page. You can try refreshing the page, or you
          can
          enjoy our livestreams and highlights on our&nbsp;
          <a href="https://www.youtube.com/channel/UC-2KSeUU5SMCX6XLRD-AEvw/">YouTube Channel</a>
        </div>
        <div className="info p-3">
          <p>The following error was encountered trying to access the page:</p>
          <pre className="mb-0 text-center" style={{ color: 'red' }}>{error.message}</pre>
          <ErrorFeedbackForm triggeringError={error} subject="Error Report: Website Error"/>
          <p className="mt-3">Thanks for supporting explore.org!</p>
        </div>
      </div>
    )
  ;

  const displayedCopy = errorCopy;

  return (<div className="react-redux-modal">
    <div className="rr-modals">
      <div className="rrm-holder" style={{ zIndex: 9990 }}>
        <div className="scroll">
          <div className="rrm-content m-medium">
            <div className="rrm-body">
              <div>
                {displayedCopy}
              </div>
            </div>
          </div>
        </div>
        <div className="rrm-shadow" />
      </div>
    </div>
  </div>
  );
};

export default ServerError;
